import { render, staticRenderFns } from "./WinConditions.vue?vue&type=template&id=5fa87eb7&"
import script from "./WinConditions.vue?vue&type=script&lang=js&"
export * from "./WinConditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports